import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from '../../utils/axios';
//
import { dispatch } from '../store';

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: null,
};

const slice = createSlice({
  name: 'newsletters',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;

export function saveNewsletters({ email, name }, callback, onError) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/newsletter/create', { email, name });
      if (callback) callback(response);
    } catch (error) {
      if (onError) onError(error?.response);
      dispatch(slice.actions.hasError(error));
    }
  };
}
